var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.browerWin)?_c('div',{staticClass:"brower"},[_vm._v("\n    "+_vm._s(_vm.$t('addfriend.browserWin'))+"\n  ")]):_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }